import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import styled, { css } from 'styled-components';
const Text = styled.div ``;
const PrimaryStyles = css `
  border: 0;
  background-color: ${brand.secondary.red};
  color: ${brand.primary.purple};
  border-radius: 1000000px;
  overflow: hidden;

  &:before {
    ${transition('transform')};

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${brand.primary.offWhite};
    border-radius: 1000000px;
    transform: translateX(calc(-100% - 2px));
  }

  [data-variant='light'] & {
    span& {
      button.focus-ring &,
      button:hover &,
      a.focus-ring & {
        background-color: ${brand.primary.purple};
        color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        a:hover & { 
          background-color: ${brand.primary.purple};
          color: ${brand.primary.offWhite};
        }
      }
    }

    &:not(span) {
      &.focus-ring,
      &:hover,
      &:active {
        background-color: ${brand.primary.purple};
        color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        &:hover { 
          background-color: ${brand.primary.purple};
          color: ${brand.primary.offWhite};
        }
      }
    }

    &.focus-ring {
      outline-color: ${brand.primary.purple};
    }

    &:before {
      background-color: ${brand.primary.purple};
    }
  }

  [data-variant='dark'] & {
    span& {
      button.focus-ring &,
      button:hover &,
      a.focus-ring & {
        background-color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        a:hover & { 
          background-color: ${brand.primary.offWhite};
        }
      }
    }

    &:not(span) {
      &.focus-ring,
      &:active {
        background-color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        &:hover { 
          background-color: ${brand.primary.offWhite};
        }
      }
    }

    &.focus-ring {
      outline-color: ${brand.primary.offWhite};
    }

    &:before {
      background-color: ${brand.primary.offWhite};
    }
  }

  @media (hover: hover) {
    &:hover { 
      background-color: ${brand.primary.offWhite};

      &:before {
        transform: translateX(0);
      }
    }
  }

  &.focus-ring,
  &:active,
  &[data-toggle-on='true'] {
    background-color: ${brand.primary.offWhite};

    &:before {
      transform: translateX(0);
    }
  }
`;
const OutlineStyles = css `
  background-color: transparent;
  border-radius: 1000000px;
  overflow: hidden;

  &:before {
    ${transition('transform')};

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${brand.primary.offWhite};
    border-radius: 1000000px;
    transform: translateX(calc(-100% - 2px));
  }

  [data-variant='light'] & {
    color: ${brand.primary.purple};
    border: 1px solid ${brand.primary.purple};

    span& {
      button.focus-ring &,
      button:hover &,
      a.focus-ring &,
      a[data-toggle-on='true'] & {
        border-color: ${brand.primary.purple};
        background-color: ${brand.primary.purple};
        color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        a:hover & { 
          border-color: ${brand.primary.purple};
          background-color: ${brand.primary.purple};
          color: ${brand.primary.offWhite};
        }
      }
    }

    &:not(span) {
      &.focus-ring,
      &:active,
      &[data-toggle-on='true'] {
        border-color: ${brand.primary.purple};
        background-color: ${brand.primary.purple};
        color: ${brand.primary.offWhite};
      }

      @media (hover: hover) {
        &:hover { 
          border-color: ${brand.primary.purple};
          background-color: ${brand.primary.purple};
          color: ${brand.primary.offWhite};
        }
      }
    }

    &.focus-ring {
      outline-color: ${brand.primary.purple};
    }

    &:before {
      background-color: ${brand.primary.purple};
    }
  }

  [data-variant='dark'] & {
    color: ${brand.primary.offWhite};
    border: 1px solid ${brand.primary.offWhite};

    span& {
      button.focus-ring &,
      
      a.focus-ring &,
      a[data-toggle-on='true'] & {
        background-color: ${brand.primary.offWhite};
        color: ${brand.primary.purple};
      }

      @media (hover: hover) {
        button:hover &,
        a:hover & { 
          background-color: ${brand.primary.offWhite};
          color: ${brand.primary.purple};
        }
      }
    }

    &:not(span) {
      &.focus-ring,
      &:hover,
      &:active,
      &[data-toggle-on='true'] {
        background-color: ${brand.primary.offWhite};
        color: ${brand.primary.purple};
      }

      @media (hover: hover) {
        &:hover { 
          background-color: ${brand.primary.offWhite};
          color: ${brand.primary.purple};
        }
      }
    }

    &.focus-ring {
      outline-color: ${brand.primary.offWhite};
    }

    &:before {
      background-color: ${brand.primary.offWhite};
    }
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }

  span& {
    button.focus-ring &,    
    a.focus-ring &,
    a[data-toggle-on='true'] & {
      &::before {
        transform: translateX(0);
      }
    }

    @media (hover: hover) {
      button:hover &,
      a:hover & { 
        &::before {
          transform: translateX(0);
        }
      }
    }
  }

  &:not(span) {
    &.focus-ring,
    &:active,
    &[data-toggle-on='true'] {
      &::before {
        transform: translateX(0);
      }
    }

    @media (hover: hover) {
      &:hover { 
        &::before {
          transform: translateX(0);
        }
      }
    }
  }
`;
const OutlineAltStyles = css `
  background-color: transparent;
  border-radius: 1000000px;
  overflow: hidden;

  &:before {
    ${transition('transform')};

    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${brand.secondary.red};
    border-radius: 1000000px;
    transform: translateX(calc(-100% - 2px));
  }

  [data-variant='light'] & {
    color: ${brand.primary.purple};
    border: 1px solid ${brand.primary.purple};

    &.focus-ring {
      outline-color: ${brand.primary.purple};
    }
  }

  [data-variant='dark'] & {
    color: ${brand.primary.offWhite};
    border: 1px solid ${brand.primary.offWhite};

    span& {
      button.focus-ring &,      
      a.focus-ring &,
      a[data-toggle-on='true'] & {
        color: ${brand.primary.purple};
      }

      @media (hover: hover) {
        button:hover &,
        a:hover & { 
          color: ${brand.primary.purple};
        }
      }
    }

    &:not(span) {
      &.focus-ring,
      &:active,
      &[data-toggle-on='true'] {
        color: ${brand.primary.purple};
      }

      @media (hover: hover) {
        &:hover { 
          color: ${brand.primary.purple};
        }
      }
    }

    &.focus-ring {
      outline-color: ${brand.primary.offWhite};
    }

    &:before {
      background-color: ${brand.secondary.red};
    }
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }

  span& {
    button.focus-ring &,    
    a.focus-ring &,
    a[data-toggle-on='true'] & {
      background-color: ${brand.secondary.red};
      border-color: ${brand.secondary.red};

      &::before {
        transform: translateX(0);
      }
    }

    @media (hover: hover) {
      button:hover &,
      a:hover & { 
        background-color: ${brand.secondary.red};
        border-color: ${brand.secondary.red};

        &::before {
          transform: translateX(0);
        }
      }
    }
  }

  &:not(span) {
    &.focus-ring,
    &:active,
    &[data-toggle-on='true'] {
      background-color: ${brand.secondary.red};
      border-color: ${brand.secondary.red};

      &::before {
        transform: translateX(0);
      }
    }

    @media (hover: hover) {
      &:hover { 
        background-color: ${brand.secondary.red};
        border-color: ${brand.secondary.red};

        &::before {
          transform: translateX(0);
        }
      }
    }
  }
`;
const Wave = styled.div `
  ${transition('max-width')};

  overflow: hidden;
  max-width: 0;
  color: ${brand.secondary.red};

  svg {
    display: block;
    margin-right: 5px;
    height: 30px;
  }
`;
const Arrow = styled.div `
  ${transition('transform')};

  margin: 0 0 0 5px;

  svg {
    display: block;
    height: 12px;
  }
`;
const TextOnlyStyles = css `
  display: inline-flex;
  align-items: center;
  border: 1px solid transparent;
  background: none;
  color: ${brand.primary.purple};
  padding: 0;

  [data-variant='dark'] & {
    color: ${brand.primary.offWhite};
  }

  ${Text} {
    margin-bottom: 2px;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }

  span& {
    button.focus-ring &,
    a.focus-ring & {
      ${Wave} {
        max-width: 50px;
      }

      ${Arrow} {
        transform: translateX(15%);
      }
    }

    @media (hover: hover) {
      button:hover &,
      a:hover & { 
        ${Wave} {
          max-width: 50px;
        }

        ${Arrow} {
          transform: translateX(15%);
        }
      }
    }
  }

  &:not(span) {
    &:hover,
    &:active,
    &.focus-ring {
      ${Wave} {
        max-width: 50px;
      }

      ${Arrow} {
        transform: translateX(15%);
      }
    }

    @media (hover: hover) {
      &:hover { 
        ${Wave} {
          max-width: 50px;
        }

        ${Arrow} {
          transform: translateX(15%);
        }
      }
    }
  }
`;
const Icon = styled.div `
  display: inline-flex;
  align-items: center;
  margin: 0 0 0 8px;

  svg {
    max-height: 24px;
    width: 20px;
  }

  &[data-position='left'] {
    order: -1;
    margin: 0 8px 0 0;
  }
`;
const Button = styled.button `
  ${transition('color, background-color, border-color')};

  display: inline-flex;
  padding: 10px ${fluid(20, 25)} 12px;
  height: ${fluid(46, 48)};
  user-select: none;
  text-decoration: none;
  position: relative;
  align-items: center;

  ${Text} {
    ${fonts.graphikCompact.medium};

    font-size: ${fluid(18, 20)};
    line-height: ${fluid(24, 26)};
    display: inline-block;
    vertical-align: middle;
    position: relative;
    z-index: 2;
  }

  &:disabled {
    opacity: 0.66;
    pointer-events: none;

    &:hover {
      opacity: 0.66;
    }
  }

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('color, background-color, border-color, transform')};

    span& {
      button:active &,
      a:active & {
        transform: translateY(1.5px);
      }
    }

    &:not(span) {
      &:active {
        transform: translateY(1.5px);
      }
    }
  }

  ${({ branding }) => {
    switch (branding) {
        case 'textOnly':
            return TextOnlyStyles;
        case 'solid':
            return PrimaryStyles;
        case 'outline':
            return OutlineStyles;
        case 'outline-alt':
            return OutlineAltStyles;
        default:
            break;
    }
}}
`;
const ArrowButton = styled.button `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: transparent;
  border: none;
  width: ${fluid(58, 60)};
  height: ${fluid(48, 50)};
  padding: 0;
  color: var(--fgColour, ${brand.primary.purple});

  &:first-child {
    justify-content: flex-end;

    svg {
      transform: scaleX(-1);
    }
  }

  &:disabled {
    opacity: 0.66;
    pointer-events: none;

    &:hover {
      opacity: 0.66;
    }
  }

  svg {
    display: block;
    height: ${fluid(12, 15)};
  }

  /* Mobile click styles - button should mimic press */
  @media ${until(Device.TabletLarge)} {
    ${transition('transform', 0.15)};

    &:active {
      transform: translateY(1.5px);
    }
  }
`;
const ButtonInner = styled.div `
  ${transition('max-width')};

  border: 2px solid var(--fgColour, ${brand.primary.purple});
  border-radius: 5000000px;
  max-width: ${fluid(46, 48)};
  width: ${fluid(56, 58)};
  height: ${fluid(46, 48)};
  display: flex;
  align-items: center;
  justify-content: center;

  ${ArrowButton}.focus-ring & {
    outline: auto;
    outline-offset: 3px;
    outline-style: solid;
    outline-width: 2px;
  }

  ${ArrowButton}.focus-ring & {
    max-width: ${fluid(56, 58)};
  }

  @media (hover: hover) {
    ${ArrowButton}:hover & {
      max-width: ${fluid(56, 58)};
    }
  }

  @media ${until(Device.TabletLarge)} {
    max-width: ${fluid(56, 58)};
  }
`;
const ButtonIcon = styled.div `
  ${transition('transform')};
  position: relative;
  line-height: 0;
  transform: translateX(0);

  ${ArrowButton}:last-child.focus-ring &{
    transform: translateX(7px);
  }

  @media (hover: hover) {
    ${ArrowButton}:last-child:hover & {
      transform: translateX(7px);
    }
  }

  ${ArrowButton}.focus-ring & {
    transform: translateX(-7px);
  }

  @media (hover: hover) {
    ${ArrowButton}:hover & {
      transform: translateX(-7px);
    }
  }

  @media ${until(Device.TabletLarge)} {
    transform: translateX(-7px);

    ${ArrowButton}:last-child & {
      transform: translateX(7px);
    }
  }
`;
const HoverLine = styled.div `
  ${transition('transform')};

  position: absolute;
  left: 0;
  top: 50%;
  width: 22px;
  height: 3px;
  transform-origin: 0;
  transform: translate(2px, -50%) scaleX(0);
  background-color: var(--fgColour, ${brand.primary.purple});

  ${ArrowButton}:last-child & {
    transform-origin: 100%;
    left: auto;
    right: 0;
    transform: translate(-2px, -50%) scaleX(0);
  }

  ${ArrowButton}.focus-ring & {
    transform: translate(2px, -50%) scaleX(1);
  }

  @media (hover: hover) {
    ${ArrowButton}:hover & {
      transform: translate(2px, -50%) scaleX(1);
    }
  }

  ${ArrowButton}:last-child.focus-ring & {
    transform: translate(-2px, -50%) scaleX(1);
  }

  @media (hover: hover) {
    ${ArrowButton}:last-child:hover & {
      transform: translate(-2px, -50%) scaleX(1);
    }
  }

  @media ${until(Device.TabletLarge)} {
    transform: translate(2px, -50%) scaleX(1);

    ${ArrowButton}:last-child & {
      transform: translate(-2px, -50%) scaleX(1);
    }
  }
`;
export const ButtonStyles = {
    Arrow,
    ArrowButton,
    Button,
    ButtonIcon,
    ButtonInner,
    HoverLine,
    Icon,
    Text,
    Wave,
};
